import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-subtitle-1 font-weight-medium" }
const _hoisted_2 = { class: "text-caption opacity-80" }
const _hoisted_3 = {
  key: 2,
  class: "plan-container"
}
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = ["aria-label"]

import {computed, onMounted, ref} from 'vue'
import {getPlanImageUrl, useLotoAreaStore} from '@/api/loto'
import {LotoPlan, planFullName} from '@/types/Loto'
import {t} from '@/lib/utils'


export default /*@__PURE__*/_defineComponent({
  __name: 'AssetPositionDialog',
  props: {
    planId: {},
    marker: {},
    label: {},
    positionText: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit
const plan = ref<LotoPlan | null>(null)
const imageUrl = ref<string | null>(null)
const errorMessage = ref('')
const markerStyle = computed(() => ({left: `${props.marker.x * 100}%`, top: `${props.marker.y * 100}%`}))
const labelAlignmentClass = computed(() => props.marker.x >= .5 ? 'marker-label--left' : 'marker-label--right')
const markerVerticalClass = computed(() => props.marker.y <= .15 ? 'marker-point--below' : 'marker-point--above')

onMounted(async () => {
  try {
    const store = useLotoAreaStore()
    await store.load()
    plan.value = store.planById(props.planId) ?? null
    if (!plan.value?.image_path) throw new Error(t('assetPosition.imageUnavailable'))
    imageUrl.value = await getPlanImageUrl(plan.value.image_path)
    if (!imageUrl.value) throw new Error(t('assetPosition.imageUnavailable'))
  } catch (error: any) {
    errorMessage.value = error?.message ?? t('assetPosition.imageUnavailable')
  }
})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "d-flex flex-column asset-dialog" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_toolbar, {
        color: "toolbar",
        density: "compact"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, {
            icon: "mdi-map-marker-radius",
            class: "ms-4 me-2"
          }),
          _createVNode(_component_v_toolbar_title, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(planFullName)(plan.value)), 1),
              _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.positionText), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_btn, {
            icon: "mdi-close",
            "aria-label": _unref(t)('assetPosition.close'),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
          }, null, 8, ["aria-label"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_text, { class: "pa-2 pa-sm-4 overflow-auto" }, {
        default: _withCtx(() => [
          (errorMessage.value)
            ? (_openBlock(), _createBlock(_component_v_alert, {
                key: 0,
                type: "error",
                variant: "tonal",
                density: "compact"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(errorMessage.value), 1)
                ]),
                _: 1
              }))
            : (!imageUrl.value)
              ? (_openBlock(), _createBlock(_component_v_skeleton_loader, {
                  key: 1,
                  type: "image",
                  height: "400"
                }))
              : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("img", {
                    src: imageUrl.value,
                    alt: _unref(planFullName)(plan.value),
                    class: "plan-image",
                    draggable: "false"
                  }, null, 8, _hoisted_4),
                  _createElementVNode("div", {
                    class: _normalizeClass(['marker-point', markerVerticalClass.value]),
                    style: _normalizeStyle(markerStyle.value),
                    "aria-label": `${_ctx.label} ${_ctx.positionText}`
                  }, [
                    _cache[1] || (_cache[1] = _createElementVNode("span", { class: "pulse-ring" }, null, -1)),
                    _createVNode(_component_v_icon, {
                      class: "marker-pin",
                      icon: "mdi-map-marker",
                      color: "#CE0058",
                      size: "48"
                    }),
                    (_ctx.label)
                      ? (_openBlock(), _createBlock(_component_v_chip, {
                          key: 0,
                          class: _normalizeClass(['marker-label', labelAlignmentClass.value]),
                          color: "#CE0058",
                          size: "small",
                          label: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.label), 1)
                          ]),
                          _: 1
                        }, 8, ["class"]))
                      : _createCommentVNode("", true)
                  ], 14, _hoisted_5)
                ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})